$( ".y-menu li a" ).click(function() {
  var val = $(this).attr("href");
    if(val != null) {
        var currentCollection = val.substr(val.indexOf("#") + 1);
    } 
    var firstEl = $('.for_distance');
    var secondEl = $("#"+currentCollection);
    if (firstEl.length && secondEl.length) {
      var firstPoint = firstEl.offset().top;
      var secondPoint = secondEl.offset().top;
      var distance = firstPoint - secondPoint;
      console.log(distance);
    }
  
    $(".off-canvas--main-content").css("top",distance);
    $(".off-canvas--close").click();
});

var ul = $('.js-ul').html();
ul = $.trim(ul);
ul = ul.split('\n');
const newArr = ul.filter((a) => a);
var newUl = '<ul>';
for (const element of newArr) {
    newUl = newUl+'<li>'+element+'</li>';
}
newUl = newUl+'</ul>';
console.log(newUl);
$('.js-ul').html(newUl);